import React, { useState, useEffect, useRef } from 'react';
import Button from '../Components/Buttons';
import '../Components/Card.css';
import { CustomInput } from "./CustomFormElements";

const Card = ({ parameters, onSave, onCancel }) => {

  const [position, setPosition] = useState({ x: window.innerWidth / 2 - 250, y: 100 });
  const [isDragging, setIsDragging] = useState(false);
  const dragStartPos = useRef({ x: 0, y: 0 });
  const [internalParameters, setInternalParameters] = useState(parameters || []);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragStartPos.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y
    };
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragStartPos.current.x,
          y: e.clientY - dragStartPos.current.y
        });
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  const handleParamChange = (index, newValue) => {
    const updatedParams = [...internalParameters];
    updatedParams[index] = {
      ...updatedParams[index],
      value: newValue
    };
    setInternalParameters(updatedParams);
  };

  return (
    <div
      className="pdf-card"
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
      onMouseDown={handleMouseDown}
    >

      <div className="pdf-card-header">
        Generate Test PDF (Drag me)
      </div>

      <div className="pdf-card-body">
        <div className="pdf-card-table-header">
          <div className="col-label">Parameter</div>
          <div className="col-value">Values</div>
        </div>

     {internalParameters.map((param, index) => (
    <div key={param.key || param.name || index} className="pdf-card-row">
      <div className="col-label">
        {param.name}
      </div>
      <div className="col-value">
        <CustomInput
            id={`param-${index}`}
            placeholder="Enter value"
            value={param.value || ''}
            onChange={(id, newValue) => handleParamChange(index, newValue)}
        />
      </div>
    </div>
))}
      </div>

      <div className="pdf-card-footer">
        <div onMouseDown={(e) => e.stopPropagation()}>
          <Button variant='primary' size='medium' onClick={() => onSave(internalParameters)}>
            Generate
          </Button>
        </div>
        <div onMouseDown={(e) => e.stopPropagation()}>
          <Button variant='danger' size='medium' onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Card;
